import * as searchKeyEffects from './search-key/search-key.effects'
import * as customerEffects from './customer/customer.effects'
import { sharedEffects, userEffects } from 'shared-lib'

export const effects = { ...userEffects, ...searchKeyEffects, ...customerEffects, ...sharedEffects }
